import {
  type HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";

export interface SignalRNotification {
  typeKey: string;
  title: string;
  message: string;
  type: string;
  subjectId?: string | null;
}

export function createHubConnection(): HubConnection {
  return new HubConnectionBuilder()
    .withUrl("/hubs/notifications")
    .withAutomaticReconnect([0, 1000, 2000, 5000, 10000, 30000])
    .configureLogging(LogLevel.Warning)
    .build();
}